export const CREDIT_CARD = 'CREDIT_CARD';
export const DEBIT_CARD = 'DEBIT_CARD';
export const TOP_UP = 'TOP_UP';